// Quotation Draft Stage related codes goes here

// NPM Imports
import React, { Fragment } from "react";

// Components Imports
import { QuotationDraftBtns } from "../QuotationTopBarBtns";

// Declarations

export default function QuotationDraftStage(props) {
  return (
    <Fragment>
      <div className="document-meta">
        <div
          data-test="quotationtopbarbtns-document-meta"
          className="document-btns">
          <QuotationDraftBtns {...props} />
        </div>
      </div>
    </Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/QuotationTopBarV2/QuotationStages/QuotationDraftStage.js